<template>
    <div>
        <div class="d-flex flex-column justify-content-center">
            <div class="d-flex justify-content-between">
                <div class="col-auto">
                    <p></p>
                </div>
                <div class="d-flex col-auto">
                    <h2>PLAZOS</h2>
                    <InfoToolTip :info="info" />
                </div>
                <b-btn class="col-auto" @click="$router.go(-1)"><i class="fas fa-arrow-left mr-2"></i>Atrás</b-btn>
            </div>
            <b-table ref="tablePlazos" selectable select-mode="multi" @row-selected="onRowSelected" hover :items="items"
                :fields="fields" id="plazos-table" class="mt-3 mb-3">
                <template #cell(opciones)="{ item, rowSelected }">
                    <b-form-checkbox v-if="item.estado != 1 && item.estado != 5" style="pointer-events: none;" :checked="rowSelected"
                        :id="String(item.id)"></b-form-checkbox>
                </template>
                <template #cell(importe_con_gd)="{ item }">
                    <span>{{ item.importe_con_gd | formatear_precio }}</span>
                </template>
                <template #cell(estado_string)="{ item }">
                    <b>
                        <span :class="'p-2 ' + (item.estado == 0 ? 'bg-warning' : (item.estado == 1 ? 'bg-success text-white' : (item.estado == 4 ? 'bg-danger text-white' : 'bg-dark text-white' )))">{{ item.estado_string }}
                            <InfoToolTip style="color: white !important;" v-if="item.estado == 5" :info="'No podrá pagar ningún plazo más hasta que no pague los FALLIDOS DEFINITIVOS'" />
                        </span>
                    </b>
                </template>
            </b-table>
            <div class="d-flex justify-content-center">
                <b-pagination
                    v-model="pagination.currentPage"
                    :total-rows="pagination.rows"
                    :per-page="pagination.perPage"
                    @change="actualizar"
                ></b-pagination>
            </div>
        </div>
        <div v-if="rowsSelected.length > 0" class="d-flex">
            <div class="d-flex flex-column justify-content-center align-items-center ml-auto mr-md-5">
                <h4 class="mr-3">Total a pagar: {{ importe_a_pagar | formatear_precio }} </h4>
                <button @click="showModal('pagarPlazos')" name="button" class="button effect-button large-button">
                    <span>Realizar pago</span>
                </button>
            </div>
        </div>

        <PagoPlazosPerfilModal @close="closeModal('pagarPlazos')" :plazos="plazosIds" :tipo_venta="tipo_venta" @actualizar="actualizar" />
    </div>
</template>

<script>
import InfoToolTip from '@/components/common/InfoToolTip';
import PagoPlazosPerfilModal from '@/components/frontend/compra/components/PagoPlazosPerfilModal';

export default {
    props: [
        'plazos',
        'tipo_venta',
        'pagination'
    ],
    data() {
        return {
            fields: [
                { key: 'fecha', label: 'Fecha de cobro', class: 'text-center' },
                { key: 'importe_con_gd', label: 'Total', class: 'text-center' },
                { key: 'estado_string', label: 'Estado', class: 'text-center' },
                { key: 'opciones', label: '', class: 'text-center' }
            ],
            rowsSelected: [],
            info:
                `<p>En este apartado puedes ver el estado de los <b>plazos de tu ` + (this.tipo_venta == 'plazosBase' ? 'deportista' : 'abono') + `</b> y 
                    también seleccionar los plazos <b>pendientes</b> y/o <b>fallidos</b> para pagarlos cómodamente</p>`
        }
    },
    methods: {
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal) {
            this.$modal.hide(modal);
        },
        onRowSelected(rowsSelected) {
            let selected = [];
            rowsSelected.forEach((element, index) => {
                if (element.estado === 1) {
                    this.$refs.tablePlazos.unselectRow(index);
                } else {
                    selected.push(element);
                }
            });
            this.rowsSelected = selected;
        },
        setRowVariant(item) {
            return (item._rowVariant = "row-disabled");
        },
        actualizar(page) {
            this.$emit('actualizar', page);
        }
    },
    computed: {
        items() {
            let items = [];
            items = Object.assign([], this.plazos);
            items.forEach(item => {
                if (item.estado === 1) {
                    item = this.setRowVariant(item);
                }
            });

            return items;
        },
        importe_completo() {
            let total = 0;

            this.plazos.forEach(plazo => {
                total = total + plazo.importe_con_gd
            });

            return total
        },
        importe_a_pagar() {
            return this.rowsSelected.reduce((acumulador, plazo) => acumulador + plazo.importe_con_gd, 0);
        },
        plazosIds() {
            return this.rowsSelected.map(plazo => plazo.id);
        }
    },
    components: { InfoToolTip, PagoPlazosPerfilModal }
}
</script>

<style>
.table-row-disabled {
    pointer-events: none !important;
}
</style>